export default __webpack_public_path__ + "static/med-carts-d852ca5e57fa5e46128b94277cb44338.jpg";